import { Events } from '@Core/components/snackbarController/events';

const addSnackbar = (options = {}) => {
  const event = new Events.Add(options);

  window.dispatchEvent(event);
};

const removeSnackbar = (snackbarId) => {
  const event = new Events.Remove(snackbarId);

  window.dispatchEvent(event);
};

export { addSnackbar, removeSnackbar };
